document.addEventListener("turbolinks:load", function () {
  const subdomainField = document.getElementById("subdomain-field");
  const simpleDomainField = document.getElementById("simple-domain-field");

  if (subdomainField && simpleDomainField) {
    subdomainField.addEventListener("input", function () {
      const alphabetsOnly = subdomainField.value.replace(/[^a-zA-Z]/g, "");
      simpleDomainField.value = alphabetsOnly;
    });
  }
});
